var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveGeminiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99786 11.9957C5.99786 11.1646 5.83934 10.3849 5.51803 9.65655C5.20957 8.92824 4.78115 8.2899 4.24134 7.75009C3.70153 7.21028 3.06748 6.78615 2.33916 6.47769C1.61085 6.15637 0.831132 5.99786 0 5.99786C0.831132 5.99786 1.61085 5.84363 2.33916 5.53088C3.06748 5.20957 3.70582 4.78115 4.24134 4.24134C4.78115 3.70153 5.20528 3.06748 5.51803 2.33916C5.83934 1.61085 5.99786 0.831132 5.99786 0C5.99786 0.831132 6.15209 1.61085 6.46483 2.33916C6.78615 3.06748 7.21457 3.70582 7.75437 4.24134C8.29418 4.78115 8.92824 5.20957 9.66084 5.53088C10.3891 5.83934 11.1689 5.99786 12 5.99786C11.1689 5.99786 10.3891 6.15637 9.66084 6.47769C8.93252 6.78615 8.29418 7.21028 7.75437 7.75009C7.21457 8.2899 6.78615 8.92396 6.46483 9.65655C6.15637 10.3849 5.99786 11.1646 5.99786 11.9957Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGeminiIcon);
export default __webpack_public_path__ + "static/media/active-gemini-icon.bd4d744edabcaecfb49d0c8123b29c5d.svg";
export { ForwardRef as ReactComponent };